import { render } from "./AdditionalModal.vue?vue&type=template&id=5db9a9f8&ts=true"
import script from "./AdditionalModal.vue?vue&type=script&lang=ts"
export * from "./AdditionalModal.vue?vue&type=script&lang=ts"

import "./AdditionalModal.vue?vue&type=style&index=0&id=5db9a9f8&lang=scss"

import exportComponent from "/Users/andrski/developing/web/client_shina_m1/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__